export enum EmailFormLabelsEnum {
  EMAILS = 'Emails',
  DRAFTS = 'Drafts',
  ATTACH_FILES = 'Attach Files',
  CLEAR_ATTACHMENTS = 'Clear Attachments',
  DOWNLOAD_ATTACHMENTS = 'Download Attachments',
  SEND = 'Send',
  EMAIL_EMPTY = 'No Emails Found',
}
